import { render, staticRenderFns } from "./404-page.vue?vue&type=template&id=794c00af&scoped=true"
import script from "./404-page.vue?vue&type=script&lang=js"
export * from "./404-page.vue?vue&type=script&lang=js"
import style0 from "./404-page.vue?vue&type=style&index=0&id=794c00af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c00af",
  null
  
)

export default component.exports